import React, { useEffect, useRef, useState } from "react";
import './SolicitudDeReembolso.scss'
import html2pdf from 'html2pdf.js'
import { getTaxi } from "./VerIncidenciasIntegracion";
import { useParams } from "react-router-dom";
import InputText from "../../../components/atoms/InputText/InputText";

const SolicitudDeReembolso = () => {
    const params = useParams()
    const [Taxis, setTaxis] = useState([])
    const [total, setTotal] = useState(0)
    useEffect(() => {

        const taxis = async () => {
            await getTaxi(params.id_incidente, setTaxis)

        }
        taxis()

    }, [])
    useEffect(() => {
        if (Taxis.length > 0) {
            let monto = 0
            Taxis.map((item) => {
                monto = monto + item.monto
            })
            setTotal(monto)

        }
    }, [Taxis])
   

    return (
        <div className="SolicitudDeReembolso">
            <main>
                <div className="excel-header">Administración y Finanzas</div>
                {/* <!-- Meta información --> */}
                <table className="w-full excel-table excel-meta mt-4 mb-3" style={{ borderCollapse: 'collapse' }}>
                    <tr>
                        <td className="font-medium">Tipo de Doc.: Registro</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="font-medium text-right">Estado: <span className="font-semibold text-green-700">Efectivo</span></td>
                    </tr>
                    <tr>
                        <td className="font-medium">Código del formato: AF-POE-04.F01</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="font-medium text-right">Fecha de efectividad: <span>14 de mayo del 2024</span></td>
                    </tr>
                    <tr>
                        <td className="font-medium">Código del Doc. Relacionado: AF-POE-04</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="font-medium text-right">Versión No.: <span>2.0</span></td>
                    </tr>
                </table>
                <div className="w-full text-right text-sm italic text-gray-600 mb-2">Página 1 de 1</div>
                <h2 className="text-lg font-semibold text-blue-900 mt-2 mb-4">Solicitud de Servicio de Taxi / Uber</h2>

                {/* <!-- Instrucciones --> */}
                <div className="mb-4 px-2 py-2 bg-blue-50 rounded">
                    <div className="font-semibold text-blue-800 mb-1">Instrucciones de llenado:</div>
                    <ol style={{ listStyleType: "decimal" }} className="ml-5 excel-instrucciones text-gray-800 text-sm">
                        <li>Completar los campos con la información solicitada.</li>
                        <li>En la columna de Tipo de Incidente y Causa, indicar, de acuerdo con Anexo 1, el motivo que derivó la solicitud del taxi / Uber.</li>
                        <li>De no aplicar algún campo colocar: N/A.</li>
                        <li>Adjuntar las evidencias necesarias de acuerdo con la incidencia presentada, como se describe en Anexo 1.</li>
                        <li>Firmar de validado y entregar a área Contable.</li>
                    </ol>
                </div>

                {/* <!-- Tabla de incidencias --> */}
                <table className="w-full excel-table mb-2" style={{ borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th>FECHA</th>
                            <th>ID DE INCIDENTE</th>
                            <th>TIPO DE INCIDENTE<br />ANEXO A</th>
                            <th>CAUSA<br />ANEXO A</th>
                            <th>ID DE REEMBOLSO</th>
                            <th>ID DE DESCUENTO</th>
                            <th>CLIENTE</th>
                            <th>MONTO REEMBOLSO TAXIS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* <!-- Dejamos los campos vacíos para llenado dinámico --> */}
                        {

                            Taxis.map((item) => {

                                return (
                                    <tr>
                                        <td className="h-10">{item.fecha}</td>
                                        <td style={{textAlign:'end'}}>{params.id_incidente}</td>
                                        <td><input style={{ width: "fit-content",fontSize:"11px "}}></input></td>
                                        <td>{item.CAUSA}</td>
                                        <td style={{textAlign:'end'}}>{item.id}</td>
                                        <td>{item.ID_DESCUENTO}</td>
                                        <td>{item.EMPRESA}</td>
                                        <td style={{textAlign:'end'}}>{
                                            new Intl.NumberFormat('es-MX', {
                                                style: 'currency',
                                                currency: 'MXN'
                                            }).format(item.monto)
                                        }</td>
                                    </tr>
                                )
                            })
                        }


                    </tbody>
                </table>

                {/* <!-- Totales --> */}
                <table className="excel-table mb-4" style={{ borderCollapse: "collapse", width: "250px" }}>
                    <tr>
                        <th className="excel-totales text-right" style={{ width: "60%" }}>TOTAL</th>
                        <td className="text-blue-900 text-right font-bold"  style={{ width: "40%",textAlign:'end' }}>
                            {new Intl.NumberFormat('es-MX', {
                                style: 'currency',
                                currency: 'MXN'
                            }).format(total)}</td>
                    </tr>
                </table>

                {/* <!-- Firmas --> */}
                <table className="w-full excel-table excel-firmas mb-6" style={{ borderCollapse: "collapse",marginBottom:'10px' }}>
                    <tr>
                        <th className="excel-mini-th" style={{ width: "17%" }}>Solicitado por:</th>
                        <td style={{ width: "17%",borderTop:"0",borderLeft:"0",borderRight:"0" }}></td>
                        <td style={{ width: "17%",borderTop:"0",borderLeft:"0",borderRight:"0" }}></td>
                        
                        <th className="excel-mini-th" style={{ width: "18%" }}>Validado por:</th>
                        <td style={{ width: "17%",borderTop:"0",borderLeft:"0",borderRight:"0" }}></td>
                        <td style={{ width: "17%",borderTop:"0",borderLeft:"0",borderRight:"0" }}></td>
                        <td style={{ width: "17%",borderTop:"0",borderLeft:"0",borderRight:"0" }}></td>
                    </tr>
                    <tr>
                        <td style={{borderTop:"0",borderLeft:"0",borderRight:"0",fontSize:"11px"}} className="font-thin text-xs text-center pb-2 pt-6 border-t-0 border-b-2 border-gray-300" >Nombre y firma</td>
                        <td style={{borderBottom:"1px solid black",borderTop:"0",borderLeft:"0",borderRight:"0"}} className="border-t-0 border-b-2 border-gray-300"></td>
                        <td style={{borderBottom:"1px solid black",borderTop:"0",borderLeft:"0",borderRight:"0"}} className="border-t-0 border-b-2 border-gray-300"></td>
                        <td style={{borderTop:"0",borderLeft:"0",borderRight:"0",fontSize:"11px"}} className="font-thin text-xs text-center pb-2 pt-6 border-t-0 border-b-2 border-gray-300" >Nombre y firma</td>
                        <td style={{borderBottom:"1px solid black",borderTop:"0",borderLeft:"0",borderRight:"0"}}className="border-t-0 border-b-2 border-gray-300"></td>
                        <td style={{borderBottom:"1px solid black",borderTop:"0",borderLeft:"0",borderRight:"0"}}className="border-t-0 border-b-2 border-gray-300"></td>
                        <td style={{borderBottom:"1px solid black",borderTop:"0",borderLeft:"0",borderRight:"0"}} className="border-t-0 border-b-2 border-gray-300"></td>
                    </tr>
                </table>

                <div className="mb-2 text-base font-semibold text-red-800">
                    IMPORTANTE:
                    <span className="font-normal text-gray-800">Presentar una solicitud para cada Tipo de Incidencia. NO MEZCLAR NINGUNO DE LOS SIETE TIPOS DE INCIDENTES.</span>
                </div>

                {/* <!-- Anexo 1 --> */}
                <div className="mt-8 mb-2 text-blue-900 font-bold text-md">
                    Anexo 1. Tipos de Incidentes para Solicitud de Taxi / Uber.
                </div>
                {/* <table className="excel-table w-full mb-1" style={{ borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th className="excel-mini-th" style={{ width: "10%" }}>No.</th>
                            <th className="excel-mini-th" style={{ width: "35%" }}>Tipo de Incidente</th>
                            <th className="excel-mini-th" style={{ width: "40%" }}>Causa</th>
                            <th className="excel-mini-th" style={{ width: "15%" }}>Observaciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="h-10"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table> */}
                <table class="incident-table">
                    <thead>
                        <tr>
                            <th>Tipos de Incidentes</th>
                            <th>Posible Causa</th>
                            <th>Evidencia de Cumplimiento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* <!-- 1. Operador Indispuesto --> */}
                        <tr>
                            <td class="group-title" rowspan="5">1. Operador Indispuesto</td>
                            <td>1.1 Operador dormido.</td>
                            <td>1. ID de incidencia.</td>
                        </tr>
                        <tr>
                            <td>1.2 Omisión de parada.</td>
                            <td>2. ID de descuento de taxi.</td>
                        </tr>
                        <tr>
                            <td>1.3 Operador se niega a realizar servicio.</td>
                            <td>3. Solicitud de taxi con firma de validación, por Talento Humano.</td>
                        </tr>
                        <tr>
                            <td>1.4 Detenido por Autoridad Vial.</td>
                            <td>4. Comprobante de pago (incluye inicio y destino de servicio).</td>
                        </tr>
                        <tr>
                            <td>1.5 Operador indispuesto (enfermo).</td>
                            <td>5. Justificante Médico del IMSS (solo aplica cuando Operador se reporte enfermo - con fecha de reporte).</td>
                        </tr>

                        {/* <!-- 2. Tráfico --> */}
                        <tr>
                            <td class="group-title" rowspan="2">2. Tráfico</td>
                            <td>2.1 Congestionamiento vial (accidente).</td>
                            <td>1. Nota periodística o evidencia fotográfica con fecha.</td>
                        </tr>
                        <tr>
                            <td>2.2 Congestionamiento vial (manifestación).</td>
                            <td>2. Nota periodística o evidencia fotográfica con fecha.</td>
                        </tr>

                        {/* <!-- 3. Clima --> */}
                        <tr>
                            <td class="group-title" rowspan="2">3. Clima</td>
                            <td>3.1 Lluvia o inundación.</td>
                            <td>1. Reporte meteorológico con fecha del día del incidente.</td>
                        </tr>
                        <tr>
                            <td>3.2 Niebla.</td>
                            <td>2. Reporte meteorológico con fecha del día del incidente.</td>
                        </tr>

                        {/* <!-- 4. Fallas Mecánicas --> */}
                        <tr>
                            <td class="group-title" rowspan="2">4. Fallas Mecánicas</td>
                            <td>4.1 Fallas en unidad (ponchadura, frenos, etc.).</td>
                            <td>1. Reporte de taller o bitácora de unidad.</td>
                        </tr>
                        <tr>
                            <td>4.2 Incendio o falla total.</td>
                            <td>2. Reporte del siniestro y bitácora de unidad.</td>
                        </tr>

                        {/* <!-- 5. Otros --> */}
                        <tr>
                            <td class="group-title" rowspan="2">5. Otros</td>
                            <td>5.1 Falta de servicio (error de programación).</td>
                            <td>1. Registro de programación errónea validado por Talento Humano.</td>
                        </tr>
                        <tr>
                            <td>5.2 Robo o violencia.</td>
                            <td>2. Denuncia ante la autoridad competente.</td>
                        </tr>
                    </tbody>
                </table>
                <div className="text-xs italic text-gray-600 mt-4">
                    Los campos vacíos serán llenados dinámicamente por el sistema.
                </div>
            </main>
        </div>
    )
}
export default SolicitudDeReembolso